import React, {Component} from 'react';
import {Field, reduxForm} from 'redux-form';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import { injectIntl } from 'react-intl';
import {messages} from  '../common/Translations';

class Price extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div className="form-group row">
                    <label className="col-sm-2 col-form-label">
                        <b>{this.props.intl.formatMessage(messages.price)}</b>
                    </label>
                <div className="col-sm-10 form-group row p-r-0">

                        <div className="col-sm-4 p-r-0">
                            <Field
                                className="form-control"
                                name="amount"
                                type="number"
                                min="0"
                                max='1000000000'
                                component='input'
                            />
                            <small className="form-text text-muted">
                                {this.props.intl.formatMessage(messages.priceVat)}
                            </small>
                        </div>
                        {/*<div className="col-sm-4 p-r-0">
                            <Field
                                className="form-control clickable"
                                name="currencyId"
                                type="select"
                                component="select"
                            >
                                {
                                    this.props.currencies.map((currency) => {
                                        return <option key={currency.id} value={currency.id}>{currency.name}</option>
                                    })
                                }
                            </Field>
                        </div>
                        <div className="col-sm-4 p-r-0">
                            <Field
                                className="form-control clickable"
                                name="priceTypeId"
                                type="select"
                                component="select"
                            >
                                {
                                    this.props.types.map(priceType => {
                                        return <option key={priceType.id} value={priceType.id}>{priceType.name}</option>;
                                    })
                                }
                            </Field>
                    </div>*/}
                </div>
            </div>
        )
    }
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators({
            /*...currencyActions,
            ...priceTypeActions,*/
        }, dispatch)
    }
}

function mapStateToProps(state, ownProps) {
    return {
        /*'currencies': state.currencies,
        'types': state.priceTypes*/
    };
}

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(Price));


// WEBPACK FOOTER //
// ./web/src/components/common/Price.jsx